import { action, computed } from '@ember/object';
import AbstractCondition, { addError } from './abstract';
import RefinementCondition from './refinement';

export const anyEmail = '*';

class EmailCondition extends AbstractCondition {
  type = 'email';

  trackedAttributes = ['email', 'eventType', 'inverse', 'linkHref', 'specificLink', 'isForeignEvent'];

  email = anyEmail;
  eventType = 'sent_email';
  inverse = false;
  specificLink = false; // true when "tracked link matching" selected
  linkHref: string | null = null; // when specificLink is true, this holds the URL to match
  refinement: RefinementCondition | null = null;
  isForeignEvent = true;

  @computed('isAnyInParent', 'isRefinable')
  get canRefine() {
    if (!this.isAnyInParent) {
      return true;
    }

    return this.isRefinable;
  }

  @computed('email', 'isAnyInParent')
  get isAny() {
    return this.email === anyEmail || this.isAnyInParent;
  }

  @computed('email')
  get isAnyInParent() {
    return this.email?.includes('any_');
  }

  @computed('isAnyInParent', 'specificLink')
  get errors() {
    let errors = {};

    if (this.isAnyInParent && this.specificLink) {
      addError(errors, 'specificLink', 'You must select a specific email to match URLs');
    }

    return errors;
  }

  @computed('refinement')
  get children() {
    return [this.refinement];
  }

  @computed('email')
  get isVariation() {
    return this.email?.includes('variation');
  }

  @action
  duplicate() {
    return EmailCondition.create({
      _event: this.event,
      eventType: this.eventType,
      inverse: this.inverse,
      specificLink: this.specificLink,
      linkHref: this.linkHref,
      email: this.email,
      refinement: this.refinement?.duplicate(),
      isForeignEvent: this.isForeignEvent,
    });
  }

  toString() {
    return 'EmailCondition';
  }
}

export default EmailCondition;
